function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.4095 9.91174C17.8958 9.91174 17.4268 10.089 17.0458 10.3763V12.639C17.0458 13.0636 16.9922 13.4754 16.9004 13.8727C17.3022 14.2317 17.8277 14.4572 18.4095 14.4572C19.6649 14.4572 20.6822 13.4399 20.6822 12.1845C20.6822 10.929 19.6649 9.91174 18.4095 9.91174V9.91174Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.59 18.0937H8.86275C5.85002 18.0937 3.4082 15.6518 3.4082 12.6391V9.00275C3.4082 7.99821 4.22184 7.18457 5.22639 7.18457H15.2264C16.2309 7.18457 17.0446 7.99821 17.0446 9.00275V12.6391C17.0446 15.6518 14.6028 18.0937 11.59 18.0937V18.0937Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.95508 1.72998C7.95508 2.69998 8.86417 2.85089 8.86417 3.54816C8.86417 4.24544 7.95508 4.48725 7.95508 5.36635",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6816 1.72998C10.6816 2.69998 11.5907 2.85089 11.5907 3.54816C11.5907 4.24544 10.6816 4.48725 10.6816 5.36635",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4082 1.72998C13.4082 2.69998 14.3173 2.85089 14.3173 3.54816C14.3173 4.24544 13.4082 4.48725 13.4082 5.36635",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.1364 21.7299H4.31818C3.31364 21.7299 2.5 20.9163 2.5 19.9117H17.9545C17.9545 20.9163 17.1409 21.7299 16.1364 21.7299V21.7299Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcoCoffee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCoffee);
export default __webpack_public_path__ + "static/media/ico-coffee.3cddbfbe.svg";
export { ForwardRef as ReactComponent };